import { defineStore } from 'pinia';
export const useDialogStore = defineStore('dialog', {
    state: () => ({
        show: false,
        persistent: false,
        loading: false,
        title: '',
        text: '',
        html: '',
        ok: undefined,
        cancel: undefined
    }),
    getters: {},
    actions: {
        set(data) {
            Object.assign(this.$state, data);
        },
        hide() {
            this.show = false;
            this.persistent = false;
            this.loading = false;
            this.title = '';
            this.text = '';
            this.html = '';
            this.ok = undefined;
            this.cancel = undefined;
        }
    },
});
